<template>
  <b-container fluid class="basemaps-container">
    <b-row>
      <b-col>
        <span class="basemaps-container-title">Basemaps</span>
      </b-col>
    </b-row>
    <b-row class="basemaps-container-rows">
      <b-col>
        <b-form-group
          v-for="scheme in basemaps"
          :key="scheme.schemeKey"
          class="m-0"
        >
          <b-form-radio
            v-model="selectedScheme"
            name="scheme-selections"
            :value="scheme.schemeKey"
          >
            <span>{{ scheme.name }}</span>
          </b-form-radio>
          <b-container v-if="selectedScheme === scheme.schemeKey">
            <b-row>
              <b-col>
                <b-form-group>
                  <b-form-checkbox-group
                    v-model="selectedLayers"
                    switches
                    stacked
                    v-for="layer in scheme.layers"
                    :key="layer.layerKey"
                  >
                    <b-form-checkbox :value="layer.layerKey">{{
                      layer.name
                    }}</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-container>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  name: 'Basemaps',
  data() {
    return {
      visibleLayers: [],
      basemaps: [
        {
          name: 'Accessible',
          schemeKey: 'accessible',
          layers: [
            {
              name: 'Blue Base Bathymetry',
              layerKey: 'blue-base-bathymetry',
            },
            {
              name: 'Blue Axial Base',
              layerKey: 'blue-axial-base-bathymetry',
            },
            {
              name: 'Blue Axial Caldera',
              layerKey: 'blue-axial-caldera-bathymetry',
            },
            {
              name: 'Blue Hydrate Endeavor',
              layerKey: 'blue-hydrate-bathymetry',
            },
            {
              name: 'Blue Washington Offshore',
              layerKey: 'blue-washington-offshore-bathymetry',
            },
          ],
        },
        {
          name: 'Standard',
          schemeKey: 'standard',
          layers: [
            {
              name: 'Base Bathymetry',
              layerKey: 'base-bathymetry',
            },
            {
              name: 'Hydrate Endeavour',
              layerKey: 'hydrate-bathymetry',
            },
            {
              name: 'Axial Slope Base',
              layerKey: 'axial-bathymetry',
            },
            {
              name: 'Axial Caldera',
              layerKey: 'axial-caldera-bathymetry',
            },
            {
              name: 'Washington Offshore',
              layerKey: 'washington-offshore-bathymetry',
            },
          ],
        },
      ],
    };
  },
  mounted() {
    const { layers } = _.find(this.basemaps, ['schemeKey', this.selectedScheme]);
    layers.forEach((layer) => {
      if (this.map.getLayoutProperty(layer.layerKey, 'visibility') === 'visible') {
        this.visibleLayers.push(layer.layerKey);
      }
    });
    this.selectedLayers = this.visibleLayers;
  },
  computed: {
    ...mapState({
      map: (state) => state.webmap,
    }),
    selectedScheme: {
      get() {
        return this.$store.state.currentBaseMapScheme;
      },
      set(value) {
        this.setCurrentBasemapScheme({ scheme: value });
      },
    },
    /**
     * Setup a getter and setter for a list of selected infrastructures
     */
    selectedLayers: {
      get() {
        return this.$store.state.selectedBathymetryLayers;
      },
      set(value) {
        this.setSelectedBathymetryLayers({ selected: value });
      },
    },
  },
  methods: {
    ...mapActions(['setSelectedBathymetryLayers', 'setCurrentBasemapScheme']),
  },
  watch: {
    selectedLayers(newVal, oldVal) {
      let diff = [];
      if (oldVal.length > newVal.length) {
        diff = _.difference(oldVal, newVal);
      } else if (newVal.length > oldVal.length) {
        diff = _.difference(newVal, oldVal);
      }
      if (diff.length === 1) {
        const toggledLayer = diff[0];
        if (this.map.getLayoutProperty(toggledLayer, 'visibility') === 'visible') {
          this.map.setLayoutProperty(toggledLayer, 'visibility', 'none');
        } else {
          this.map.setLayoutProperty(toggledLayer, 'visibility', 'visible');
        }
      }
    },
    selectedScheme(newVal) {
      const blueLayers = _.find(this.basemaps, ['schemeKey', 'accessible']).layers;
      const rainbowLayers = _.find(this.basemaps, ['schemeKey', 'standard']).layers;
      if (newVal === 'accessible') {
        blueLayers.forEach((layer) => {
          this.selectedLayers.push(layer.layerKey);
          this.map.setLayoutProperty(layer.layerKey, 'visibility', 'visible');
        });
        rainbowLayers.forEach((layer) => {
          _.pull(this.selectedLayers, layer.layerKey);
          this.map.setLayoutProperty(layer.layerKey, 'visibility', 'none');
        });
      } else {
        rainbowLayers.forEach((layer) => {
          this.selectedLayers.push(layer.layerKey);
          this.map.setLayoutProperty(layer.layerKey, 'visibility', 'visible');
        });
        blueLayers.forEach((layer) => {
          _.pull(this.selectedLayers, layer.layerKey);
          this.map.setLayoutProperty(layer.layerKey, 'visibility', 'none');
        });
      }
    },
  },
};
</script>

<style>
.basemaps-container {
  margin-top: 5px;
  margin-bottom: 5px;
}

.basemaps-container-rows {
  max-height: 150px;
  overflow-y: scroll;
}

.basemaps-container-title {
  font-weight: bold;
  font-size: 15px;
}
</style>
